import classnames from 'classnames';
import React from 'react';

import { IconWarningTriangle16 } from '../icons/ic-warning-triangle';

export enum InputCountLabelStyle {
    default = 'default',
    light = 'light'
}

type InputCountLabelProps = {
    className?: string;
    style?: InputCountLabelStyle;
    currentCount: number;
    recommendedCount?: number;
    maxCount?: number;
    recommendedMessage?: string;
    overLengthMessage?: string;
};

export default function InputCountLabel({
    className,
    style,
    currentCount,
    recommendedCount,
    maxCount,
    recommendedMessage,
    overLengthMessage
}: InputCountLabelProps) {
    const hasReachedMaxLength = maxCount && currentCount >= maxCount;
    const hasReachedRecommendedLength = recommendedCount >= 0 && currentCount > recommendedCount;
    const message = hasReachedMaxLength
        ? overLengthMessage
        : hasReachedRecommendedLength
          ? recommendedMessage
          : undefined;
    const baseTextColorClassName = style === InputCountLabelStyle.light ? 'text-white/50' : 'text-darkBlue/50';
    return (
        <div
            className={classnames(className, 'flex space-x-[2px] text-body-12 items-center justify-between', {
                'text-[#FE7600]': hasReachedRecommendedLength,
                'text-red': hasReachedMaxLength,
                [baseTextColorClassName]: !hasReachedMaxLength && !hasReachedRecommendedLength
            })}>
            {message && <span>{message}</span>}
            <span className="duration-150 ml-auto">
                {[
                    currentCount,
                    currentCount < maxCount && recommendedCount >= 0 ? recommendedCount : (maxCount ?? recommendedCount)
                ]
                    .filter((it) => it >= 0)
                    .join('/')}
            </span>
            {hasReachedMaxLength && (
                <IconWarningTriangle16
                    className={classnames(
                        'flex h-[12px] duration-150 overflow-clip origin-center',
                        hasReachedMaxLength ? 'max-w-auto opacity-100' : 'w-0 opacity-0'
                    )}
                />
            )}
        </div>
    );
}
